import React from 'react';
import { SectionLink } from './SectionLink';

/**
 * The flour's own block. The Products page exists mainly to give this form a
 * presence, so it gets a section rather than only a card.
 *
 * Framed by use, never by process (Jarvis, 2026-09-04): what the flour does
 * for a bake you already make. How the flour is made is Tier S and stays off
 * the site.
 *
 * 2026-09-12 — the pouch is REAL: printed, filled, sealed, on the table at
 * King Arthur's cottage bakery Sunday. The "coming soon" framing is gone and
 * the photo is the actual bag, not the render.
 *
 * The bloom is here because it is a FAILURE MODE, not a courtesy
 * (marketing/creative/flour-pouch-requirements.md, R-1): dumped in dry this
 * reads sandy and the customer blames the product. Print item 02 carries the
 * statutory set and has no room for it, so until the artwork grows a panel
 * the website is the only surface that can say it. Ratio is n=1 (150 g : 120 g
 * hot water, the 09-09 bake) and grind-dependent, so it is given as the way we
 * do it rather than as a spec.
 */
export function FlourSpotlight() {
  return (
    <section className="section fade-in">
      <div className="section-label">New Form</div>
      <h2>TrueNooch™ Flour</h2>
      <p style={{ maxWidth: '58ch' }}>
        You do not need a new recipe. TrueNooch™ Flour goes into the one you already bake —
        brownies, cookies, biscuits, a quick bread — in place of part of the flour. It behaves
        like a thirsty whole-grain flour with a savory backbone: it darkens the crumb, makes it
        denser and damper, and makes chocolate taste more like chocolate.
      </p>
      <p style={{ maxWidth: '58ch' }}>
        Same eight ingredients as the Round, dried and milled. 350 g in a recyclable paper pouch,
        filled and sealed by hand in Denver.
      </p>

      <div className="flour-panel">
        <div className="flour-panel-label">Bloom it first — this is the step that matters</div>
        <ul className="flour-panel-list">
          <li>
            <span className="flour-panel-k">Wake it up</span> in hot water before anything else
            joins it — we use about <strong>120 g of hot water to 150 g of flour</strong>, and let
            it sit <strong>15 minutes</strong>.
          </li>
          <li>
            <span className="flour-panel-k">Why</span> — go straight in dry and it drinks from the
            rest of your batter on the way to the oven, and you taste it as a faint sandiness.
            Bloomed, that disappears and the crumb comes out smooth.
          </li>
          <li>
            <span className="flour-panel-k">Then swap it in</span> for part of the flour in your
            recipe — as part of the flour weight, not a sprinkle on top. We run it one-to-one
            against the other flour in brownies.
          </li>
          <li>
            <span className="flour-panel-k">Expect</span> a darker, denser bake with a savory floor
            under the sweet — and a longer bake, because there is more water in the pan.
          </li>
        </ul>
      </div>

      <SectionLink to="/recipes/flour-brownies">Bake the brownies we bring to market</SectionLink>
    </section>
  );
}
